import {TaskTotalsHeaders as Totals} from '../renders/TaskTotalsHeaders';
import React from 'react';
import {hasFeatureFlag} from '../../../../shared/util/FeatureUtil';

export const useGroupColumns = customFieldColumnCount => {
	const hasFinancialCategoriesUpdate = hasFeatureFlag('financial_categories_update');

	const columns = [
		{
			key: 'name',
			Total: ({row}) => <span>{row?.generatedName || row?.name}</span>,
		},
		{key: 'indicator'},
		{key: 'project'},
		{key: 'project_deadline'},
		{key: 'project_stage'},
		{key: 'rateCard'},
		{key: 'client'},
		{key: 'task_startDate'},
		{key: 'task_endDate'},
		{key: 'task_createdAt'},
		{key: 'role'},
		{key: 'assignees'},
		{key: 'status'},
		{key: 'phase'},
		{key: 'phase_startDate'},
		{key: 'phase_endDate'},
		{key: 'sprint'},
		{key: 'sprint_startDate'},
		{key: 'sprint_endDate'},
		{key: 'progress'},
		{
			key: 'estimate_hours',
			Total: ({row}) => <Totals.EstimateHours totals={row.taskTotals} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'estimate_points',
			Total: ({row}) => <Totals.EstimatePoints totals={row.taskTotals} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'projected',
			Total: ({row}) => <Totals.ProjectedHours totals={row.taskTotals} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'reported',
			Total: ({row}) => <Totals.ReportedHours totals={row.taskTotals} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'remaining_hours',
			Total: ({row}) => <Totals.RemainingHours totals={row.taskTotals} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'remaining_points',
			Total: ({row}) => <Totals.RemainingPoints totals={row.taskTotals} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'difference_hours',
			Total: ({row}) => <Totals.DifferenceHours totals={row.taskTotals} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'difference_points',
			Total: ({row}) => <Totals.DifferencePoints totals={row.taskTotals} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'planned_revenue',
			Total: ({row}) => <Totals.PlannedRevenue totals={row.taskTotals} currency={row.currency} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{
			key: 'actual_revenue',
			Total: ({row}) => <Totals.ActualRevenue totals={row.taskTotals} currency={row.currency} />,
			showCondition: !hasFinancialCategoriesUpdate,
		},
		{key: 'hours-estimated', showCondition: hasFinancialCategoriesUpdate},
		{key: 'hours-actual', showCondition: hasFinancialCategoriesUpdate},
		{key: 'hours-actual-billable', showCondition: hasFinancialCategoriesUpdate},
		{key: 'hours-actual-non-billable', showCondition: hasFinancialCategoriesUpdate},
		{key: 'remaining-work-hours', showCondition: hasFinancialCategoriesUpdate},
		{key: 'projected-total-hours', showCondition: hasFinancialCategoriesUpdate},
		{key: 'estimated-points', showCondition: hasFinancialCategoriesUpdate},
		{key: 'remaining-work-points', showCondition: hasFinancialCategoriesUpdate},
		{key: 'estimated-billable-value-of-service', showCondition: hasFinancialCategoriesUpdate},
		{key: 'actual-billable-value-of-service', showCondition: hasFinancialCategoriesUpdate},
		{key: 'remaining-work-billable', showCondition: hasFinancialCategoriesUpdate},
		{key: 'projected-total-billable', showCondition: hasFinancialCategoriesUpdate},
		{key: 'estimated-revenue', showCondition: hasFinancialCategoriesUpdate},
		{key: 'actual-revenue', showCondition: hasFinancialCategoriesUpdate},
		{key: 'remaining-work-revenue', showCondition: hasFinancialCategoriesUpdate},
		{key: 'projected-total-revenue', showCondition: hasFinancialCategoriesUpdate},
		{key: 'projected-over-under', showCondition: hasFinancialCategoriesUpdate},
		{key: 'approved'},
		{key: 'labels'},
		...Array.from({length: customFieldColumnCount}, (_, index) => ({key: `custom-field-${index}`})),
	];

	return columns.filter(column => column.showCondition ?? true);
};
